import React from 'react';
import PropTypes from 'prop-types';

const RadioSwitch = ({
    checked,
    className,
    handleOnChange,
    id,
    optionClasses,
    options,
    ...otherProps
}) => {
    return (
        <div
            className={`form-control-radio-switch ${className}`}
            {...otherProps}>
            {options.map(option => {
                return (
                    option.value && (
                        <span
                            className={`form-check form-check-inline 
                            ${option.className || ''} 
                            ${getOptionClasses(
                                optionClasses && optionClasses[option.value]
                            )}`}
                            style={option.style}
                            key={option.value}>
                            <input
                                className="form-check-input"
                                type="radio"
                                name={id}
                                id={`${id}-${option.value}`}
                                value={option.value}
                                checked={option.value === checked}
                                onChange={e => {
                                    handleOnChange(e.target.value);
                                }}
                            />
                            <label
                                className="form-check-label"
                                htmlFor={`${id}-${option.value}`}>
                                {option.name}
                            </label>
                        </span>
                    )
                );
            })}
        </div>
    );
};

function getOptionClasses(classMap) {
    if (classMap) {
        const classes = [];
        if (classMap.size) {
            classes.push(`form-check-inline-${classMap.size}`);
        }
        if (classMap.noclip) {
            classes.push('form-check-inline-noclip');
        }
        return classes.join(' ');
    } else {
        return '';
    }
}

RadioSwitch.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string,
            name: PropTypes.node,
            className: PropTypes.string
        })
    ),
    optionClasses: PropTypes.shape({
        size: PropTypes.oneOf(['sm', 'lg', 'xl']),
        noclip: PropTypes.bool
    }),
    checked: PropTypes.string,
    handleOnChange: PropTypes.func,
    className: PropTypes.string,
    id: PropTypes.string.isRequired
};

RadioSwitch.defaultProps = {
    className: ''
};

export default RadioSwitch;
